import { render, staticRenderFns } from "./sucursalesToApprove.vue?vue&type=template&id=5a6d201e&scoped=true"
import script from "./sucursalesToApprove.vue?vue&type=script&lang=js"
export * from "./sucursalesToApprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6d201e",
  null
  
)

export default component.exports